export const hasValidLength = (string) => {
  if (typeof string !== 'string') {
    return string;
  }

  return string.length >= 12;
};
